function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* googleCharts.js Version: 1.5.0 Built On: 2018-12-30 */
var loadScript = Symbol('loadScript');
var instance = Symbol('instance');

var _instance;

var GoogleChartsManager = /*#__PURE__*/function () {
  function GoogleChartsManager() {
    _classCallCheck(this, GoogleChartsManager);

    if (this[instance]) {
      return this[instance];
    }

    this[instance] = this;
  }

  _createClass(GoogleChartsManager, [{
    key: instance,
    get: function get() {
      return _instance;
    }
  }, {
    key: instance,
    set: function set(value) {
      _instance = value;
    }
  }, {
    key: "reset",
    value: function reset() {
      _instance = null;
    }
  }, {
    key: loadScript,
    value: function value() {
      if (!this.scriptPromise) {
        this.scriptPromise = new Promise(function (resolve) {
          var body = document.getElementsByTagName('body')[0];
          var script = document.createElement('script');
          script.type = 'text/javascript';

          script.onload = function () {
            GoogleCharts.api = window.google;
            GoogleCharts.api.charts.load('current', {
              packages: ['corechart', 'table']
            });
            GoogleCharts.api.charts.setOnLoadCallback(function () {
              resolve();
            });
          };

          script.src = 'https://www.gstatic.com/charts/loader.js';
          body.appendChild(script);
        });
      }

      return this.scriptPromise;
    }
  }, {
    key: "load",
    value: function load(callback, type) {
      var _this = this;

      return this[loadScript]().then(function () {
        if (type) {
          var config = {};

          if (type instanceof Object) {
            config = type;
          } else if (Array.isArray(type)) {
            config = {
              packages: type
            };
          } else {
            config = {
              packages: [type]
            };
          }

          _this.api.charts.load('current', config);

          _this.api.charts.setOnLoadCallback(callback);
        } else {
          if (typeof callback != 'function') {
            throw 'callback must be a function';
          } else {
            callback();
          }
        }
      });
    }
  }]);

  return GoogleChartsManager;
}();

var GoogleCharts = new GoogleChartsManager();
export default GoogleChartsManager;
export { GoogleCharts };